<template>
    <div class="sidebar-container">
        <sidebar-head :sidebar-dashboard="sidebarDashboard"></sidebar-head>
        <sidebar-list></sidebar-list>
        <sidebar-social-networks></sidebar-social-networks>
        <sidebar-user-agreement></sidebar-user-agreement>
    </div>
</template>

<script>
import SidebarHead from '@/components/sidebar/sections/SidebarHead';
import SidebarList from '@/components/sidebar/sections/SidebarList';
import SidebarSocialNetworks from '@/components/sidebar/sections/SidebarSocialNetworks';
import SidebarUserAgreement from '@/components/sidebar/sections/SidebarUserAgreement';
export default {
    name: 'Sidebar',
    components: {
        SidebarHead,
        SidebarList,
        SidebarSocialNetworks,
        SidebarUserAgreement,
    },
    props: {
        sidebarDashboard: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar-container {
    display: inline-grid;
    grid-auto-rows: 20rem 26rem 12rem 10rem;
    width: auto;
    height: 100%;
    background-color: #dce3e9;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
}
@media (max-width: $lg-up) {
    .sidebar-container {
        display: none;
    }
}
</style>
